// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const deleteWebhookPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Webhook ID"),
});

export const deleteWebhookHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Webhook deleted successfully
 */
export const deleteWebhook200Schema = z.object({});

/**
 * @description Webhook not found
 */
export const deleteWebhook404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const deleteWebhookMutationResponseSchema = z.lazy(() => deleteWebhook200Schema);
